import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Divider from 'dashboard/components/Divider';
import IntegrationHeroCard from 'dashboard/components/IntegrationHeroCard';
import IntegrationStep from 'dashboard/components/IntegrationStep';
import Card from 'design-system/components/Card';
import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';
import APIOnlyImage from 'images/dashboard/getting-started/api-only.svg';

const UnorderedList = styled('ul')`
  margin-left: ${Spacing[5]};
`;

const ListItem = styled('li')`
  margin: ${Spacing[2]} 0px;
  font-size: ${({ theme }) => theme.text.paragraph.md.fontSize};
  line-height: ${({ theme }) => theme.text.paragraph.md.lineHeight};
`;

export default () => {
  return (
    <>
      <IntegrationHeroCard title='Server APIs' image={APIOnlyImage}>
        With Server API integrations, you can collect or store user information on your side, and
        pass that information to Persona for a variety of purposes — from verification to enrichment
        or even additional orchestration.
      </IntegrationHeroCard>
      <Card>
        <Card.Body>
          <Card.Title>How to use this method</Card.Title>
          <IntegrationStep title='Determine the scope' stepNumber={1}>
            <Paragraph color='primary'>
              Determine what you’d like to do in Persona with the data you want to pass in. Some
              common use cases include running Verifications or enriching your data with Persona
              Reports.
            </Paragraph>
            <Spacer height={1} />
            <Paragraph color='primary'>
              Note that in a Verifications use case, an Inquiry is still created to process the
              verification, while the API-only reports use case can be used with or without an
              Inquiry being created.
            </Paragraph>
            <Spacer height={1} />
            <Paragraph color='primary'>
              Once you’ve chosen what you’d like to do, it’s important to figure out what
              information must be collected to get the right results. Some examples:
            </Paragraph>
            <UnorderedList>
              <ListItem>
                A database verification may require name, birthdate, and Social Security number
              </ListItem>
              <ListItem>A watchlist report may require name and birthdate</ListItem>
            </UnorderedList>
          </IntegrationStep>
          <Divider full />
          <IntegrationStep
            title='Talk to our sales team'
            stepNumber={2}
            dataMarketingId='getting-started__api-sales-team'
          >
            <Paragraph color='primary'>
              Once you’ve settled on your use case and what you’d like to do, our sales team can
              talk you through how it might work and the pros and cons.
            </Paragraph>
            <Spacer height={1} />
            <Paragraph color='primary'>
              Some use cases may not be recommended. For example, verifying a government ID or
              document verification are best served using our other integration methods, which have
              best practices in place for capturing those types of information on a variety of
              devices.
            </Paragraph>
          </IntegrationStep>
        </Card.Body>
      </Card>
    </>
  );
};
